import React, { useEffect, useRef, useState, useCallback } from 'react';
import Dialog from '@mui/material/Dialog';
import { IconButton, Tooltip, Typography } from '@mui/material';
import {
    cryptoCurrencyList,
    fiatCurrencyList,
    useJunoCommonFunctions,
} from '../../../client/Juno/helpers';
import ClearIcon from '@mui/icons-material/Clear';
import PropTypes from 'prop-types';
import JunoButton from '../common/JunoButton';
import { useSelector } from 'react-redux';
import { apiService } from '../../../client/common/apiCallService';
import CustomSelect from '../common/CustomSelect';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CopyButton from '../common/CopyButton';

const Deposit = ({ open, onClose }) => {
    const { useWindowWidth } = useJunoCommonFunctions();
    const apiUrl = useSelector(state => state.config.api_url);
    const clientData = useSelector(state => state.juno.clientData);
    const windowWidth = useWindowWidth();
    const dropdownRef = useRef(null);

    const [iban, setIban] = useState({
        accounts: [],
        selectedAccount: null,
        loading: false,
        enriched: false,
    });

    return (
        !iban.loading && (
            <Dialog
                onClose={onClose}
                open={open}
                fullScreen={windowWidth < 768}
                PaperProps={{
                    className: `bg-[#1e1e2f] !rounded-lg text-black dark:!bg-[#26272B] w-[560px]`,
                }}>
                <div className="flex justify-between p-4 pb-0">
                    <Typography
                        variant="h6"
                        align="center"
                        className="font-inter font-semibold text-[24px] leading-[32px] tracking-[0.01em] align-middle dark:!text-white">
                        Deposit
                    </Typography>
                    <ClearIcon className="cursor-pointer !text-text" onClick={onClose} />
                </div>

                {iban.accounts.length > 0 ? (
                    <div className="p-4 pb-0 mb-4">
                        <CustomSelect
                            value={iban.selectedAccount}
                            onChange={value =>
                                setIban(prev => ({ ...prev, selectedAccount: value }))
                            }
                            options={iban.accounts}
                            label="Deposit Currency"
                            defaultLabel="SELECT A CURRENCY"
                        />
                        <div>
                            <p className="text-md mb-1 border-t border-[#0000001F] dark:border-[#FFFFFF1F] mt-4 py-2 test-uppercase text-balanceCard-manage">
                                To deposit funds please use this IBAN number.
                            </p>
                            <p className="block text-sm text-balanceCard-manage mb-2 uppercase tracking-wide w-full text-start">
                                IBAN
                            </p>
                            <div className="flex items-center justify-between py-2 text-xl font-mono !text-primary ">
                                {iban.selectedAccount?.iban_number}
                                <CopyButton copyValue={iban.selectedAccount?.iban_number} />
                            </div>
                        </div>

                        <div className="flex items-center text-sm !text-primary  bg-[#F4F4F5] dark:bg-[#18181B] border dark:!border-[#26272B] pt-2 mt-4 bg-gray-100 border rounded-lg px-3 py-2">
                            <InfoOutlinedIcon
                                className="text-gray-400 dark:text-white mr-2"
                                fontSize="small"
                            />
                            It can take up to <span className="font-semibold px-1">5 days</span> to
                            deposit.
                        </div>
                    </div>
                ) : (
                    <>
                        <Typography className="p-4 font-inter xxs:!text-[20px] md:!text-[18px] lg:!text-[20px] leading-5 !text-text">
                            Please contact{' '}
                            <a
                                href="mailto:support@junomoney.com"
                                className="text-blue-600 underline">
                                support@junomoney.com
                            </a>{' '}
                            for details of how to deposit funds into your Juno Money account.
                        </Typography>
                        <div className="p-4">
                            <JunoButton onClick={onClose}>close</JunoButton>
                        </div>
                    </>
                )}
            </Dialog>
        )
    );
};

Deposit.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

export default Deposit;
